import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTransportationFee,
  updateTransportationFee,
} from "./transportationFeeThunk";

const initialState = {
  fee: null,
  loading: false,
  error: null,
  success: false,
};

const transportationFeeSlice = createSlice({
  name: "transportationFee",
  initialState,
  reducers: {
    resetTransportationFeeState(state) {
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchTransportationFee.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(fetchTransportationFee.fulfilled, (state, action) => {
        state.loading = false;
        state.fee = action.payload;
        state.success = true;
      })
      .addCase(fetchTransportationFee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching transportation fee";
        state.success = false;
      })
      // UPDATE
      .addCase(updateTransportationFee.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateTransportationFee.fulfilled, (state, action) => {
        state.loading = false;
        state.fee = action.payload;
        state.success = true;
      })
      .addCase(updateTransportationFee.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error updating transportation fee";
        state.success = false;
      });
  },
});

export const { resetTransportationFeeState } = transportationFeeSlice.actions;
export default transportationFeeSlice.reducer;

